import React from "react"

export default function Navbar() {
    return (
        <nav>
            <img src="./images/airbnb-logo.png" className="nav--logo" alt="" />
        </nav>
    )
}